import type { BuildSeoHeadOptions } from '@/utils/seo'

type SeoDefaults = BuildSeoHeadOptions['defaults']

function cleanString(value: unknown) {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined
}

export function getSeoSiteName() {
  return (
    cleanString(import.meta.env.VITE_OG_SITE) ||
    cleanString(import.meta.env.VITE_SITE_TITLE) ||
    cleanString(import.meta.env.VITE_PLAUSIBLE_DOMAIN) ||
    'Website'
  )
}

export function getSeoSiteOrigin() {
  if (typeof window !== 'undefined') {
    return window.location.origin
  }

  const configuredUrl = cleanString(import.meta.env.VITE_OG_URL)
  if (configuredUrl) return configuredUrl

  const domain = cleanString(import.meta.env.VITE_PLAUSIBLE_DOMAIN)
  return domain ? `https://${domain}` : undefined
}

export function getSeoDefaults(overrides: Partial<SeoDefaults> = {}): SeoDefaults {
  const siteName = getSeoSiteName()

  return {
    title:
      overrides.title ||
      cleanString(import.meta.env.VITE_SITE_TITLE) ||
      cleanString(import.meta.env.VITE_OG_TITLE) ||
      siteName,
    description:
      overrides.description ||
      cleanString(import.meta.env.VITE_SITE_DESCRIPTION) ||
      cleanString(import.meta.env.VITE_OG_DESCRIPTION) ||
      siteName,
    image:
      overrides.image ||
      cleanString(import.meta.env.VITE_OG_IMAGE),
  }
}
